export enum Surveys {
	FIRST_SURVEY = 'firstSurvey'
}
